import { UserContext } from "App";
import SessionsApi from "Classes/API/Administration/SessionsApi";
import SearchStringOrIntReq from "Classes/Models/Requests/SearchStringOrIntReq";
import PayFromBalanceReq from "Classes/Models/Requests/Accounting/PayFromBalanceReq";
import AccountingApi from "Classes/API/AccountingApi";
import SessionsTable from "layouts/AccountingSessions/SessionsTable";
import { useContext } from "react";
import Swal from "sweetalert2";

export default function PackageSessionsTable({ packageData, setIsLoaded, setPackageData }) {
  const CurrentUser = useContext(UserContext);

  const deleteAllSessions = async () => {
    if (CurrentUser.userType !== "Admin") {
      Swal.fire({
        title: "Error",
        text: "You are not authorized to delete accounting sessions",
        icon: "error",
        confirmButtonText: "Ok",
      });
      return;
    }

    let confirmation = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (!confirmation.value) {
      return;
    }

    Swal.fire({
      title: "Loading...",
      text: "Please wait",
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      icon: "info",
    });

    let req = new SearchStringOrIntReq();
    req.SearchInt = packageData.id;

    let res = await AccountingApi.DeleteAllPackageSessions(req);

    if (res.status == "Success") {
      Swal.fire("Success", res.message, "success");

      window.location.reload();
    } else {
      Swal.fire("Failed", res.message, "error");
    }
  };

  const refundSession = async (session) => {
    let confirmation = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (!confirmation.value) {
      return;
    }

    let req = new PayFromBalanceReq();
    req.accountingSessionId = session.id;
    req.packageId = packageData.id;
    req.paymentType = "PackageSessionReturn";

    let res = await AccountingApi.PayFromBalance(req);

    if (res.status == "Success") {
      Swal.fire({
        title: "Success",
        text: "Session funds returned to package.",
        icon: "success",
        confirmButtonText: "Ok",
      }).then(() => {
        window.location.reload();
      });
    } else {
      Swal.fire({
        title: "Error",
        text: "Package deletion failed: " + res.message,
        icon: "error",
        confirmButtonText: "Ok",
      });
    }
  };

  const deleteAccountingSession = async (AccSession) => {
    if (CurrentUser.userType !== "Admin") {
      Swal.fire({
        title: "Error",
        text: "You are not authorized to delete accounting sessions",
        icon: "error",
        confirmButtonText: "Ok",
      });
      return;
    }

    let confirmation = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (!confirmation.value) {
      return;
    }

    Swal.fire({
      title: "Loading...",
      text: "Please wait",
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      icon: "info",
    });

    let req = new SearchStringOrIntReq();
    req.SearchInt = AccSession.id;

    let res = await SessionsApi.DeleteAccountingSession(req);

    if (res.status == "Success") {
      Swal.fire("Success", res.message, "success");

      setPackageData((oldPackage) => ({
        ...oldPackage,
        getAccountingSessions: oldPackage.getAccountingSessions.filter(
          (accS) => AccSession.id !== accS.id
        ),
      }));

      // window.location.reload();
    } else {
      Swal.fire("Failed", res.message, "error");
    }
  };

  const batchDeleteAccountingSessions = async (accSessions) => {
    if (CurrentUser.userType !== "Admin") {
      Swal.fire({
        title: "Error",
        text: "You are not authorized to delete accounting sessions",
        icon: "error",
        confirmButtonText: "Ok",
      });
      return;
    }

    let confirmation = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (!confirmation.value) {
      return;
    }

    Swal.fire({
      title: "Loading...",
      text: "Please wait",
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      icon: "info",
    });
    let successCount = 0;
    let errorCount = 0;
    for (let i = 0; i < accSessions.length; i++) {
      let req = new SearchStringOrIntReq();
      req.SearchInt = accSessions[i].id;
      console.log("req", req);
      let res = await SessionsApi.DeleteAccountingSession(req);
      if (res.status == "Success") {
        Swal.fire("Success", `Finished ${i + 1} of ${accSessions.length}`, "success");
        successCount++;
      } else {
        Swal.fire("Failed", `Finished ${i + 1} of ${accSessions.length}`, "error");
        errorCount++;
      }
    }
    Swal.fire("Finished", `Success: ${successCount}, Failed: ${errorCount}`, "success").then(() => {
      window.location.reload();
    });
  };

  return (
    <SessionsTable
      accountingSessions={packageData.getAccountingSessions}
      setIsLoaded={setIsLoaded}
      deleteAllSessions={deleteAllSessions}
      refundSession={refundSession}
      deleteAccountingSession={deleteAccountingSession}
      batchDeleteAccountingSessions={batchDeleteAccountingSessions}
      type="Package"
    />
  );
}
